export class RelevantContentController {
  get articles() {
    return ARTICLES[this.step] || [];
  }
}

const ARTICLES = {
  forwardMail: [
    {
      title: 'What Type of USPS Change of Address Form Should I Select?',
      link:
        '//updater.com/moving-tips/what-type-of-usps-change-of-address-form-should-i-select?utm_source=updater&utm_medium=moverapp&utm_campaign=what-type-of-usps-change-of-address-form-should-i-select',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459352918/mover%20app%20photos/mail-forwarding.jpg',
    },
    {
      title: `Mail Forwarding Timeline`,
      link:
        '//updater.com/moving-tips/mail-forwarding-timeline?utm_source=updater&utm_medium=moverapp&utm_campaign=mail-forwarding-timeline',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353317/mover%20app%20photos/mail-forwarding-timeline.jpg',
    },
    {
      title: `The World's Most Bizarre Mailboxes`,
      link:
        '//updater.com/moving-tips/the-worlds-most-bizarre-mailboxes?utm_source=updater&utm_medium=moverapp&utm_campaign=the-worlds-most-bizarre-mailboxes',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353866/mover%20app%20photos/weirdest-mailboxes.jpg',
    },
  ],
  updateAccounts: [
    {
      title: 'Who to Notify When You Move or Change Your Address',
      link:
        '//updater.com/moving-tips/who-to-notify-when-you-move-or-change-your-address?utm_source=updater&utm_medium=moverapp&utm_campaign=who-to-notify-when-you-move-or-change-your-address',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353013/mover%20app%20photos/update-accounts.png',
    },
    {
      title: `Moving? How to Update Your Voter Registration Information in Every State`,
      link:
        '//updater.com/moving-tips/moving-how-to-update-your-voter-registration-information-in-every-state?utm_source=updater&utm_medium=mover-app&utm_campaign=moving-how-to-update-your-voter-registration-information-in-every-state',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1461593240/mover%20app%20photos/voter-registration.jpg',
    },
    {
      title: `How to Update Your Drivers License and Registration with the DMV`,
      link:
        '//updater.com/moving-tips/how-to-update-your-drivers-license-and-registration-with-the-dmv?utm_source=updater&utm_medium=moverapp&utm_campaign=how-to-update-your-drivers-license-and-registration-with-the-dmv',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353911/mover%20app%20photos/dmv-change-of-address.jpg',
    },
  ],
  offers: [
    {
      title: '50 Easy Ways to Save Money on Your Move',
      link:
        '//updater.com/moving-tips/50-easy-ways-to-save-money-on-your-move?utm_source=updater&utm_medium=moverapp&utm_campaign=50-easy-ways-to-save-money-on-your-move',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353073/mover%20app%20photos/save-money-on-moving.jpg',
    },
    {
      title: `Packing Materials 101: 15 Things You Don't Need to Buy`,
      link:
        '//updater.com/moving-tips/packing-materials-101-15-things-you-dont-need-to-buy?utm_source=updater&utm_medium=moverapp&utm_campaign=packing-materials-101-15-things-you-dont-need-to-buy',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353549/mover%20app%20photos/packing-materials-101.jpg',
    },
    {
      title: `5 Ways to Get Rid of Furniture When It's Not Selling`,
      link:
        '//updater.com/moving-tips/5-ways-to-get-rid-of-your-furniture-when-its-not-selling?utm_source=updater&utm_medium=moverapp&utm_campaign=5-ways-to-get-rid-of-your-furniture-when-its-not-selling',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353963/mover%20app%20photos/sell-furniture.jpg',
    },
  ],
  utilities: [
    {
      title: 'Eco-Friendly Tips for Conserving Water, Gas, and Electricity',
      link:
        '//updater.com/moving-tips/eco-friendly-tips-for-conserving-water-gas-and-electricity?utm_source=updater&utm_medium=moverapp&utm_campaign=eco-friendly-tips-for-conserving-water-gas-and-electricity',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353126/mover%20app%20photos/connect-utilities.jpg',
    },
    {
      title: `Documents You'll Need to Start, Stop, or Transfer Utility Service`,
      link:
        '//updater.com/moving-tips/documents-youll-need-to-start-stop-or-transfer-utility-service?utm_source=updater&utm_medium=moverapp&utm_campaign=documents-youll-need-to-start-stop-or-transfer-utility-service',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353607/mover%20app%20photos/utilities-documents.jpg',
    },
    {
      title: `How to Save Money on Your Utilities (Water, Gas, Electric)`,
      link:
        '//updater.com/moving-tips/how-to-save-money-on-your-utilities-water-gas-electric?utm_source=updater&utm_medium=moverapp&utm_campaign=how-to-save-money-on-your-utilities-water-gas-electric',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459354012/mover%20app%20photos/save-money-utilities.jpg',
    },
  ],
  homeServices: [
    {
      title: 'Pros and Cons: Streaming Services vs. Cable TV',
      link:
        '//updater.com/moving-tips/pros-and-cons-streaming-services-vs-cable-tv?utm_source=updater&utm_medium=moverapp&utm_campaign=pros-and-cons-streaming-services-vs-cable-tv',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353192/mover%20app%20photos/hook-up-home-services.jpg',
    },
    {
      title: `Top Movies to Watch on Moving Day`,
      link:
        '//updater.com/moving-tips/top-movies-to-watch-on-moving-day?utm_source=updater&utm_medium=moverapp&utm_campaign=top-movies-to-watch-on-moving-day',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353660/mover%20app%20photos/top-moving-day-movies.jpg',
    },
    {
      title: `11 Brilliant Ways to Save Money on Cable, Internet and Phone When Moving`,
      link:
        '//updater.com/moving-tips/11-brilliant-ways-to-save-money-on-cable-internet-and-phone-when-moving?utm_source=updater&utm_medium=moverapp&utm_campaign=11-brilliant-ways-to-save-money-on-cable-internet-and-phone-when-moving',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459354060/mover%20app%20photos/save-money-cable.jpg',
    },
  ],
  share: [
    {
      title: 'How to Stay in Touch with Friends and Family When You Move',
      link:
        '//updater.com/moving-tips/how-to-stay-in-touch-with-friends-and-family-when-you-move?utm_source=updater&utm_medium=moverapp&utm_campaign=how-to-stay-in-touch-with-friends-and-family-when-you-move',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353259/mover%20app%20photos/share-moving-announcements.jpg',
    },
    {
      title: `Your Guide to Moving to a New City`,
      link:
        '//updater.com/moving-tips/your-guide-to-moving-to-a-new-city?utm_source=updater&utm_medium=moverapp&utm_campaign=your-guide-to-moving-to-a-new-city',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459353719/mover%20app%20photos/moving-city-guide.jpg',
    },
    {
      title: `8 Secrets to Making Friends with the New Neighbors`,
      link:
        '//updater.com/moving-tips/8-secrets-to-making-friends-with-the-new-neighbors?utm_source=updater&utm_medium=moverapp&utm_campaign=8-secrets-to-making-friends-with-the-new-neighbors',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/c_scale,h_168,w_250/v1459354115/mover%20app%20photos/new-neighbor-guide.jpg',
    },
  ],
  movingCenterDiyTruck: [
    {
      title: "Calculate Truck Size with Penske's Truck Wizard",
      link:
        '//www.pensketruckrental.com/moving-trucks/truck-wizard/?utm_source=updater&utm_medium=referral&utm_campaign=moverapp_movingcenter',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/v1467043845/mover%20app%20photos/calculate_truck_size.jpg',
    },
    {
      title: 'How to Load Your Truck Infographic',
      link:
        '//www.pensketruckrental.com/renting-from-penske/how-to-load-a-moving-truck/?utm_source=updater&utm_medium=referral&utm_campaign=moverapp_movingcenter',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/v1467043251/mover%20app%20photos/how_to_load_truck.jpg',
    },
    {
      title: 'Compare Truck Features and Side-by-Side Comparison',
      link:
        '//www.pensketruckrental.com/moving-trucks/?utm_source=updater&utm_medium=referral&utm_campaign=moverapp_movingcenter#chart',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/v1467044483/mover%20app%20photos/compare_truck_features.jpg',
    },
  ],
  movingCenterDiyStorage: [
    {
      title: 'How to Pick the Right Size Unit',
      link:
        '//www.sparefoot.com/self-storage/blog/13463-how-to-pick-the-right-size-storage-unit/?utm_source=updater&utm_medium=referral&utm_campaign=moverapp_movingcenter',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/v1467044672/mover%20app%20photos/pick_storage_unit_size.jpg',
    },
    {
      title: '5 Mistakes to Avoid When Moving Into Your Unit',
      link:
        '//www.sparefoot.com/self-storage/blog/6939-mistakes-to-avoid-when-moving-stuff-into-a-storage-unit/?utm_source=updater&utm_medium=referral&utm_campaign=moverapp_movingcenter',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/v1467045132/mover%20app%20photos/storage_mistakes_to_avoid.jpg',
    },
    {
      title: 'Storage 101: Most Frequently Asked Questions',
      link:
        '//www.sparefoot.com/self-storage/blog/7637-sparefoot-storage-guide-infographic/?utm_source=updater&utm_medium=referral&utm_campaign=moverapp_movingcenter',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/v1467045151/mover%20app%20photos/storage_faqs.jpg',
    },
  ],
  movingCenterDiySupplies: [
    {
      title: 'Top 20 Places to Find Free Moving Boxes',
      link:
        '//updater.com/moving-tips/top-20-places-to-find-free-moving-boxes?utm_source=updater&utm_medium=moverapp&utm_campaign=top_20_places_for_free_moving_boxes',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/v1467733659/mover%20app%20photos/find_free_moving_boxes.jpg',
    },
    {
      title: "Packing Materials 101: 15 Things You Don't Need to Buy",
      link:
        '//updater.com/moving-tips/packing-materials-101-15-things-you-dont-need-to-buy?utm_source=updater&utm_medium=moverapp&utm_campaign=packing_15_things_you_don%27t_need_to_buy',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/v1467733841/mover%20app%20photos/packing_materials.jpg',
    },
    {
      title: 'What NOT to Pack on Your Moving Truck',
      link:
        '//updater.com/moving-tips/beginners-guide-what-not-to-pack-on-the-moving-truck?utm_source=updater&utm_medium=moverapp&utm_campaign=what_not_to_pack_on_truck',
      imageSrc:
        '//res.cloudinary.com/updater-marketing/image/upload/v1467734332/mover%20app%20photos/what_not_to_pack_on_truck.jpg',
    },
  ],
};
